$('.form-edit-personal').on('submit', function (e) {
    e.preventDefault();
    const form = $(this);

    const checkPersonalDetailsValidation = (event) => {
        const event_detail = event.detail;

        if (event_detail.status) {
            const formData = {
                email: form.find("input[name='customer[email]']").val(),
                firstName: form.find("input[name='customer[first_name]']").val(),
                lastName: form.find("input[name='customer[last_name]']").val(),
                dob: form.find("input[name='dob']").val(),
                phone: form.find("input[name='customer[phone_number]']").val(),
            };

            $.ajax({
                type: 'POST',
                url: `/apps/bat-enhanced/customer/update`,
                data: JSON.stringify(formData),
                contentType: 'application/json',
                success: function (response) {
                    let message = '';
                    form.find('.error__signup').hide();
                    if (response.ok === true) {
                        message += window.theme.strings.successSaveInfoMessage;
                        form.find('.success__signup .message').text(message);
                        form.find('.success__signup').show();
                    } else {
                        message += window.theme.strings.genericError;
                        form.find('.error__signup .error-message').html(message);
                        form.find('.error__signup').show();
                    }
                },
                error: function (error) {
                    console.log('error', error);

                    form.find('.error__signup .error-message').text(theme.strings.genericError);
                    form.find('.error__signup').show();
                    form.find('.success__signup').hide();
                }
            });
        } else {
            setTimeout(function () {
                form.find('.form-label.error').addClass('form-label--shake')
                setTimeout(function () {
                    form.find('.form-label.error').removeClass('form-label--shake')
                }, 1000)
            }, 1000);

            form.find('.error__signup').hide();
            form.find('.success__signup').hide();
        }

        document.removeEventListener('form:validation', checkPersonalDetailsValidation, false);
    };

    document.addEventListener('form:validation', checkPersonalDetailsValidation);
});
